/* eslint-disable @next/next/no-img-element */
import { CustomBreadCrump } from "components/General/CustomBreadCrump";
import PageTitle from "components/General/PageTitle";
import { useTranslation } from "next-i18next";
import Image from "next/image";
import { CustomButton } from "../CustomButton";
import { IDoctorDetail, IMember, ITestDetail } from "interfaces/interface_members";
import parse from "html-react-parser";

const MemberPage = ({
  data,
  title,
  isDoctor,
  isMedicine,
}: {
  isDoctor?: boolean;
  data: IMember & IDoctorDetail & ITestDetail;
  title: string;
  isMedicine?: boolean;
}) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="mt-8">
        <CustomBreadCrump
          data={
            isDoctor
              ? [
                  {
                    title: t("WhyUs"),
                    href: "/",
                  },
                  { title: t("Doctors"), href: "/visitors-guide/doctors" },
                  { title: t("DoctorDetails"), href: "/" },
                ]
              : isMedicine
              ? [
                  {
                    title: t("Training"),
                    href: "/",
                  },
                  {
                    title: t("PatientEducation"),
                    href: "/",
                  },

                  { title: data?.name, href: "/" },
                ]
              : [
                  {
                    title: t("ClinicalResearchDevelopmentCenter"),
                    href: "/research",
                  },
                  { title: t(title), href: "/" },
                ]
          }
        />
      </div>
      <div className="mt-16">
        <PageTitle title={t(title)} />
      </div>
      <div className="mt-36 grid grid-cols-1 gap-24 md:grid-cols-2">
        <div
          className={`relative  ${
            isDoctor ? "md:before:block" : "before:hidden"
          } ${"ltr:before:left-[-32px] rtl:before:right-[-32px]"} before:bottom-0 before:h-[162px]  before:w-12  before:rounded-3  before:bg-primary-main  md:before:absolute `}
        >
          {!!isDoctor && data?.department && (
            <span className="relative flex w-fit items-center justify-center rounded-5 bg-white px-18 py-16 mb-8 shadow-[0px_4px_15px_rgba(0,0,0,0.15)]">
              <img
                width={48}
                height={48}
                src={data?.department?.icon}
                alt={data.department?.name}
              />
              <p className="ms-8 flex flex-col font-bold text-primary-main">
                {data?.specialtyName}
                <span className="mt-6 text-secondary-main"> {data?.department?.name}</span>
              </p>
            </span>
          )}
          {(!!data?.image || isMedicine) && (
            <Image
              className="m-auto rounded-5"
              alt={data?.name}
              src={data?.image || "/assets/test.png"}
              width={300}
              height={300}
            />
          )}
        </div>
        <div className="flex flex-col gap-48">
          {!isMedicine && (
            <div className="flex items-center justify-between">
              <p className="flex flex-col text-24 font-bold text-gray-2F3136">
                {data?.name}
                <span className="mt-10 text-16 font-normal text-primary-main">
                  {data?.specialtyTitle || data?.scientificDegrees}
                </span>
              </p>

              <div className="flex items-center">
                {!!data?.cv1 && (
                  <CustomButton
                    href={data?.cv1}
                    className="me-16 flex h-40 items-center !rounded-full border border-primary-main bg-gray-F3F3F3 !p-8 text-primary-main hover:bg-gray-F3F3F3"
                  >
                    <span className="flex">{t("File")} cv</span>
                    <i className="icon-Download ms-8 !text-primary-main" />
                  </CustomButton>
                )}
                {!!data?.cv2 && (
                  <CustomButton
                    href={data?.cv2}
                    className="flex h-40 items-center !rounded-full border border-primary-main bg-gray-F3F3F3 !p-8 text-primary-main hover:bg-gray-F3F3F3"
                  >
                    <span className="flex">{t("File")} cv</span>
                    <i className="icon-Download ms-8 !text-primary-main" />
                  </CustomButton>
                )}
              </div>
            </div>
          )}
          <div
            className={
              isDoctor
                ? "mt-48 text-14 text-gray-565656"
                : `${isMedicine ? "mt-8" : "mt-48"} text-16 text-gray-151618`
            }
          >
            {(data?.text || data?.description) && parse(data?.text || data?.description)}
          </div>
          {isMedicine && (
            <>
              <div className="mt-24 max-w-[567px] items-center justify-between rounded-10 border border-gray-D0D0D0 px-20 py-12 md:flex">
                <p className="mb-12 md:mb-0">{t("ForMorInformation")}</p>
                <div className=" flex items-center">
                  {!!data?.link && (
                    <CustomButton
                      className="rounded-full border border-primary-main bg-gray-F3F3F3 text-primary-main hover:bg-gray-F3F3F3"
                      href={data?.link}
                    >
                      link
                    </CustomButton>
                  )}
                  {!!data?.pdf && (
                    <CustomButton
                      className="ms-14 rounded-full border border-primary-main bg-gray-F3F3F3 text-primary-main hover:bg-gray-F3F3F3"
                      href={data?.pdf}
                    >
                      PDF
                    </CustomButton>
                  )}
                </div>
              </div>
              {!isMedicine && (
                <p className="mt-4 text-14 text-gray-565656">
                  {t("ForMorInformation")}
                  {t("VisitTheLaboratoryValiasrHospital")}
                </p>
              )}
            </>
          )}
          {!!isDoctor && (
            <div className="mt-24">
              <div className="flex items-center text-14 text-gray-565656 before:me-8 before:h-8 before:w-8 before:rounded-full before:bg-gray-D9D9D9">
                {t("MedicalSystemNumber")} :
                <span className="ms-16 text-gray-151618">{data?.medicalSystemNumber}</span>
              </div>
              <div className="mt-16 flex items-center text-14 text-gray-565656 before:me-8 before:h-8 before:w-8 before:rounded-full before:bg-gray-D9D9D9">
                {t("Section")} :
                <span className="ms-16 text-gray-151618">{data?.department?.name}</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export { MemberPage };
